export default {"src":"/_next/static/media/MRNA.cce51273.svg","height":18,"width":18};